/**
 * @generated SignedSource<<7845683f92b4de793e3352a1fe6a6bf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type AllWidgets_widget$data = {
  readonly __typename: string;
  readonly id: string;
  readonly roles?: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly teams?: ReadonlyArray<{
    readonly color: string | null;
    readonly icon: TeamIcon | null;
    readonly name: string;
  }>;
  readonly title: string;
  readonly withoutRoleSelected?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AllWidgetsContent_widget">;
  readonly " $fragmentType": "AllWidgets_widget";
};
export type AllWidgets_widget$key = {
  readonly " $data"?: AllWidgets_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "AllWidgets_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "teams",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "icon",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "WidgetWithTeams",
      "abstractKey": "__isWidgetWithTeams"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "WidgetWithRoles",
      "abstractKey": "__isWidgetWithRoles"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "withoutRoleSelected",
          "storageKey": null
        }
      ],
      "type": "WidgetTeamSchedule",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AllWidgetsContent_widget"
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};
})();

(node as any).hash = "cca74cf2b1489fe98fdbb28af7e33ca2";

export default node;
